export const initialState = {
    currentTemplate: "1",
    primary: "#1f63e8",
    secondary: "#6a78d1",
    information: {}
};
